import * as types from "../constants/actionTypes";
import {
  setHasMultipleGroupCompanies,
  setGroupCompanyId,
  setGroupCompanyName,
  clearContext,
  setSubsidiaryId
} from "./contextActions";

const getClaimValueByName = (user, claimName) => {
  var claim = user.claims.find(c => c.type === claimName);
  if (claim) {
    return claim.value;
  }
  return null;
};

export const login = (token, expiresIn, user) => async dispatch => {
  var groupCompanyId = getClaimValueByName(user, "GroupCompanyId");
  var groupCompanyName = getClaimValueByName(user, "GroupCompanyName");
  var multipleGroupCompany = getClaimValueByName(user, "MultipleGroupCompany");
  var actions = [
    setSubsidiaryId(null),
    setGroupCompanyId(groupCompanyId ? parseInt(groupCompanyId) : null),
    setGroupCompanyName(groupCompanyName),
    setHasMultipleGroupCompanies(multipleGroupCompany === "1"),
    { type: types.AUTH_LOGIN, token, expiresIn, user, groupCompanyId }
  ];
  await Promise.all(actions.map(action => dispatch(action)));
};
export const logout = () => async dispatch => {
  await Promise.all([
    dispatch({ type: types.AUTH_LOGOUT }),
    dispatch(clearContext())
  ]);
};
